import { useMemo } from "react";
import { TypeaheadBox, withIntl, intlShape } from "lcm-iot-commons";
import { getLocales } from "../../utils/locales";

type Props = {
  intl: intlShape;
};

function LocaleTypeahead(props: Props) {
  const options = useMemo(() => getLocales(), []);
  const { intl } = props;
  return (
    <TypeaheadBox
      {...props}
      // @ts-expect-error TS(2322) FIXME: Type '{ id: string; options: { label: string; iden... Remove this comment to see the full error message
      id="locale-name-typeahead"
      options={options}
      labelKey="label"
      valueKey="identifier"
      placeholder={intl.formatMessage({ id: "label.locale" })}
    />
  );
}

export default withIntl(LocaleTypeahead);
